import { useAuthSessionUser } from 'hooks/useAuthSession';
import { type User } from 'services/user/types';

type AuthUserQueryResult = {
  data: User | undefined;
  isError: false;
  error: null;
  isLoading: false;
  isPending: false;
  isFetching: false;
};

export function useAuthUser(): AuthUserQueryResult {
  const user = useAuthSessionUser();

  return {
    data: user,
    isError: false,
    error: null,
    isLoading: false,
    isPending: false,
    isFetching: false
  };
}
